import { Collection, CollectionDefinition, Request } from 'postman-collection';

export interface CodeSample {
  key?: number;
  desc: string;
  uri: string;
  params: { map: { [key: string]: string } };
  response?: string;
}

export class PostmanUtil {
  #collection: Collection;

  constructor(collectionJSON: CollectionDefinition) {
    this.#collection = new Collection(collectionJSON);
  }

  build() {
    const request: CodeSample[] = [];

    this.#collection.forEachItem((item) => {
      const responses = item.responses.map((res) =>
        res.body !== undefined ? res.body : ''
      );

      item.responses
        .map((res) => res.originalRequest)
        .forEach((req: Request, index: number) => {
          request.push({
            key: index,
            desc: req.description!.toString(),
            uri: `/${req.url.path?.slice(2).join('/')}`,
            params: JSON.parse(JSON.stringify({ map: this.params(req) })),
            response: responses[index],
          });
          return null;
        });
    });

    return request;
  }

  queryParams(request: Request) {
    const queryParams: { [key: string]: string } = {};
    request.url.query.map((param) => {
      if (param.key != null && param.value != null) {
        queryParams[param.key] = param.value;
      }
    });
    return queryParams;
  }

  requestBodyParams(request: Request) {
    const requestBodyParams: { [key: string]: string } = {};
    request.body?.urlencoded?.map((param) => {
      if (param.key != null && param.value != null) {
        requestBodyParams[param.key] = param.value;
      }
    });
    return requestBodyParams;
  }

  params(request: Request) {
    return {
      ...this.queryParams(request),
      ...this.requestBodyParams(request),
    };
  }
}
